import mergeConfig from 'coact/config/mergeConfig'

import StockSync from './ui/StockSync/index.js'

const config = {
  routes: {
    stockSync: {
      title: '庫存同步',
      path: '/route/stockSync',
      component: StockSync,
    },
  },
}

export default fullConfig => mergeConfig(fullConfig, config)
